import {forwardRef} from 'react';
import classNames from 'classnames';

import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';
import {getChannelIcon} from '@time-webkit/all/utils/icons/getChannelIcon';

import {ChannelType} from '@time-webkit/all/types/general';

import {ChannelSuggestionProps} from '../types';
import sharedStyles from '../styles.module.css';

import styles from './styles.module.css';

export const ChannelSuggestion = forwardRef<HTMLDivElement, ChannelSuggestionProps>((props, ref) => {
    const [headerTypography, descriptionTypography, unreadTypography] = useTypography([
        {size: TypographySize.BodyL},
        {size: TypographySize.BodyM},
        {size: TypographySize.BodyXSTrue},
    ]);

    const ChannelIcon = getChannelIcon(props.channelType, props.archived);
    const isGMChannel = props.channelType === ChannelType.GM;

    return (
        <div
            data-test-id='channelItem'
            ref={ref}
            className={classNames(sharedStyles.suggestion_container, props.className)}
            onClick={props.onClick}
        >
            <div className={styles.icon_container}>
                <ChannelIcon
                    width={20}
                    height={20}
                />
            </div>
            <div className={sharedStyles.info_container}>
                <span className={classNames(headerTypography, {[styles.ellipsis_header]: isGMChannel})}>
                    {props.name}
                </span>
                {!isGMChannel && (
                    <span
                        className={classNames(sharedStyles.description_text, styles.description, descriptionTypography)}
                    >
                        {props.description}
                    </span>
                )}
            </div>
            {Boolean(props.unreadCount) && (
                <div className={sharedStyles.unread_container}>
                    <div className={classNames(sharedStyles.unread, unreadTypography)}>{props.unreadCount}</div>
                </div>
            )}
        </div>
    );
});
